import React, { createContext, useContext } from "react";


// const ComponentContext = createContext < {
//     rel: ""
// } > (null)

// export const ComponentContextProvider = ComponentContext.Provider;
// export const useComponentContext = function () {
//     return useContext(ComponentContext);
// };


export const windowProp = {
    width: 1111,
    height: 2222
}

export const WindowPropsContext = React.createContext();
